import { Tooltip } from 'antd';
import React from 'react';
import { URInput } from '../../../shared/widgets/input';
import styles from "./scss/leftsidebar.module.scss";
type searchBarProps = {
  searchRecentChat: Function;
  searchText: string;
  unReadChat:Function;
  isUnread?: boolean;
}
export default function Searchbox({ searchRecentChat, searchText,unReadChat,isUnread }: searchBarProps) {
  return (
    <>
      <div className={styles.middlelayertop}>
        <div className={styles.searchBox}>
          <URInput value={searchText} placeHolder="Search" className="leftbarsearch chatSearch" onChange={(e: any) => searchRecentChat(e)} />
        </div>
        <span className={`icon__Filter ${styles.unreadFilter} ${isUnread?"active":""}`} onClick={()=> unReadChat()}></span>
        {/* <Tooltip placement="top" title="Close"><label className={`icon_closefill ${styles.closeiconright}`}></label></Tooltip> */}
      </div>
    </>
  );
}

